// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import PricingPage from './pages/pricing/PricingPage';
import ComingSoonPage from './pages/comingsoon/comingsoon';
//import PaymentPage from './pages/payment/PaymentPage';
import ContactForm from './pages/contactus/contactus';

const App = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route 
          path="/pricing" 
          element={
            selectedPlan ? (
              <ComingSoonPage />
              // <PaymentPage 
              //   selectedPlan={selectedPlan} 
              //   onBack={() => setSelectedPlan(null)} 
              // />
            ) : (
              <PricingPage onSelectPlan={setSelectedPlan} />
            )
          } 
        />
         <Route path="/contact" element={<ContactForm />} />
         <Route path="/comingsoon" element={<ComingSoonPage />} />
      </Routes>
    </Router>
  );
};

export default App;